import { useSurvey } from '../hooks/useSurvey';
import { questions } from '@/mocks/surveyData';
import MultiSelectChips from './MultiSelectChips';
import SingleSelectCards from './SingleSelectCards';
import ScaleSlider from './ScaleSlider';

interface QuestionScreenProps {
  questionIds: string[];
  survey: ReturnType<typeof useSurvey>;
}

export default function QuestionScreen({ questionIds, survey }: QuestionScreenProps) {
  const { answers, updateAnswer, unansweredRequiredIds } = survey;

  const getHintText = (qId: string) => {
    const q = questions[qId];
    if (!q) return '응답을 선택해주세요';
    if (q.type === 'multi-select') return '한 가지 이상 선택해주세요';
    return '응답을 선택해주세요';
  };

  return (
    <div className="flex flex-col gap-8">
      {questionIds.map((qId) => {
        const q = questions[qId];
        if (!q) return null;
        const isMissing = unansweredRequiredIds.includes(qId);

        return (
          <div key={qId}>
            <div className="mb-3">
              <div className="flex items-start gap-1.5">
                <p className="text-base font-semibold text-text-primary leading-relaxed">
                  {q.text}
                </p>
                {q.required && (
                  <span className="text-coral text-sm font-bold mt-0.5">*</span>
                )}
              </div>
              {q.sensitive && (
                <p className="text-xs text-text-secondary mt-1.5">
                  성분 안전을 위해 확인해요 · 선택 사항
                </p>
              )}
            </div>

            {q.type === 'multi-select' && (
              <MultiSelectChips
                options={q.options}
                selected={(answers[qId] as string[]) || []}
                onChange={(val) => updateAnswer(qId, val)}
              />
            )}

            {q.type === 'single-select' && (
              <SingleSelectCards
                options={q.options}
                selected={(answers[qId] as string) || null}
                onChange={(val) => updateAnswer(qId, val)}
              />
            )}

            {q.type === 'scale' && (
              <ScaleSlider
                min={q.min}
                max={q.max}
                value={(answers[qId] as number) || q.min}
                minLabel={q.minLabel}
                maxLabel={q.maxLabel}
                onChange={(val) => updateAnswer(qId, val)}
              />
            )}

            {isMissing && (
              <p className="text-coral text-xs mt-2 font-medium">
                {getHintText(qId)}
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
}